// Campo de dinero en quetzales (común a todo el sistema).
//  - Fuera de edición muestra Q y separador de miles: Q 1,965.00.
//  - Mientras se escribe acepta enteros y decimales (máx. 2), sin letras ni comas.
//  - Al salir del campo completa los dos decimales y muestra Q 625.00, Q 625.50.
//  - Vacío = sin valor (el 0.00 es solo placeholder). El valor que recibe/entrega es texto numérico limpio
//    ("1965.00"), nunca "Q 1,965.00": los cálculos y la base siguen usando números.
import React, { useState } from 'react';
import { completarDecimales, conMiles, toMoney } from '../../utils/numbers';
import './MoneyInput.css';

export default function MoneyInput({ value, onChange, onBlur, onFocus, prefijo = true, negativo = false, placeholder = '0.00', className = '', style, ...rest }) {
  const [foco, setFoco] = useState(false);
  const crudo = value == null ? '' : String(value);
  const patron = negativo ? /^-?\d*(?:\.\d{0,2})?$/ : /^\d*(?:\.\d{0,2})?$/;
  const visible = foco || crudo === '' ? crudo : prefijo ? toMoney(crudo) : conMiles(crudo);
  return (
    <span className={`mi${prefijo ? ' mi--q' : ''}${className ? ` ${className}` : ''}`} style={style}>
      <input {...rest} inputMode="decimal" autoComplete="off" placeholder={placeholder} value={visible}
        onFocus={(e) => { setFoco(true); onFocus?.(e); }}
        onChange={(e) => { const v = e.target.value.replace(/,/g, ''); if (patron.test(v)) onChange?.(v); }}
        onBlur={(e) => {
          setFoco(false);
          const listo = completarDecimales(crudo);
          if (listo !== crudo) onChange?.(listo);
          onBlur?.(e);
        }} />
    </span>
  );
}
